<template>
  <van-pull-refresh
    v-model="refreshing"
    class="document-container"
    @refresh="handleRefresh"
  >
    <van-tabs :active="active" @change="onChangeCategory">
      <van-tab v-for="(category,index) in documentCategoryList" :key="index" :title="category">
        <van-cell-group>
          <van-cell v-for="(document) in documentList" :key="document.id" :title="document.name">
            <template slot="right-icon">
              <a :href="downloadAttachUrl(document.id)">
                <van-button size="mini" type="primary">
                  下载
                </van-button>
              </a>
            </template>
          </van-cell>
        </van-cell-group>
      </van-tab>
    </van-tabs>
  </van-pull-refresh>
</template>

<script type="text/javascript">
import { getDocumentCategoryList, getDocumentList } from '@/api/other'
import { Toast } from 'vant'

export default {
  components: {
  },
  data() {
    return {
      refreshing: false,
      active: 0,
      currentCategory: '',
      documentCategoryList: [], // 分类列表
      documentList: [] // 文件列表
    }
  },
  mounted() {
    this.loadDocumentCategoryList()
  },
  methods: {
    loadDocumentCategoryList() {
      getDocumentCategoryList().then(response => {
        this.documentCategoryList = response.data
        if (this.documentCategoryList.length > this.active) { this.currentCategory = this.documentCategoryList[this.active] }
        this.loadDocumentList()
      })
    },
    loadDocumentList() {
      const category = this.currentCategory
      return new Promise((resolve, reject) => {
        getDocumentList({ category: category }).then(({ data }) => {
          this.documentList = data
          resolve(data)
        }).catch(error => {
          // 设置列表加载失败
          this.error = true
          reject(error)
        })
      })
    },
    onChangeCategory(index, category) {
      this.currentCategory = category
      this.loadDocumentList()
    },
    downloadAttachUrl(id) {
      return process.env.VUE_APP_RECSS_BASE_API + '/Document/' + id + '/File'
    },
    handleRefresh() {
      this.refreshing = true
      this.loadDocumentList().then().finally(() => {
        this.refreshing = false
        Toast.success('刷新成功')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.document-container{
  min-height: 100vh;
  background-color: #eee;
}
</style>
